import 'glamor/reset'
import '../../node_modules/flexboxgrid/dist/flexboxgrid.css'
import { css } from 'glamor'

css.global('*', {
  boxSizing: 'border-box'
})
css.global('html, body', {
  fontFamily: 'Open Sans',
  textRendering: 'optimizeLegibility',
  WebkitFontSmoothing: 'antialiased'
})
css.global('button, input, optgroup, select, textarea', {
  fontFamily: 'Open Sans'
})
css.global('button:focus', {
  outline: 0
})
css.global('a, button', {
  cursor: 'pointer'
})
css.global('a', {
  textDecoration: 'none',
  opacity: 1,
  transition: 'opacity .2s'
})
css.global('a:hover', {
  opacity: 0.9
})
css.global('img', {
  maxWidth: '100%'
})



// WEBPACK FOOTER //
// ./src/style/global.js